<template>
  <div
    v-if="visible && message"
    :class="wrapperClass"
    :role="role"
    :aria-live="ariaLive"
  >
    <div class="flex items-start gap-3">
      <div class="flex-1 text-[14px]">{{ message }}</div>
      <button
        v-if="dismissible"
        type="button"
        class="ml-2 text-[14px] leading-none opacity-70 hover:opacity-100"
        @click="dismiss"
        aria-label="Sluiten"
      >✕</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MmFlashMessage',
  props: {
    message: { type: String, default: '' },
    type: { type: String, default: 'info' }, // 'success' | 'error' | 'info'
    // Standaard geen sluitknop, zodat het exact oogt als de oude layout
    dismissible: { type: Boolean, default: false },
    autoHideMs: { type: Number, default: 0 },
    // Wanneer true: geen max-w beperking, laat de melding de volledige containerbreedte gebruiken
    fullWidth: { type: Boolean, default: false },
  },
  data(){
    return { visible: true, timer: null };
  },
  computed: {
    wrapperClass(){
      // Align with existing design tokens/colors
      const width = this.fullWidth ? '' : ' max-w-[520px]';
      switch ((this.type||'').toLowerCase()){
        case 'success':
          // Terug naar oorspronkelijke site-stijl (groen):
          // text-[14px] bg-[#d1fae5] border border-[#a7f3d0] text-[#065f46] p-3 mb-6
          return `text-[14px] bg-[#d1fae5] border border-[#a7f3d0] text-[#065f46] p-3 mb-6${width}`;
        case 'error':
          // Terug naar oorspronkelijke site-stijl (rood)
          // text-[14px] bg-[#fee2e2] border border-[#fecaca] text-[#991b1b] p-3 mb-6
          return `text-[14px] bg-[#fee2e2] border border-[#fecaca] text-[#991b1b] p-3 mb-6${width}`;
        default:
          return `text-[14px] text-[#1f2937] bg-[#e5e7eb] border border-[#d1d5db] p-3 mb-6${width}`;
      }
    },
    role(){
      return (this.type === 'error') ? 'alert' : 'status';
    },
    ariaLive(){
      return (this.type === 'error') ? 'assertive' : 'polite';
    }
  },
  watch: {
    autoHideMs: {
      immediate: true,
      handler(ms){
        if (this.timer){ clearTimeout(this.timer); this.timer = null; }
        const delay = Number(ms||0);
        if (delay > 0){
          this.timer = setTimeout(() => { this.dismiss(); }, delay);
        }
      }
    }
  },
  methods: {
    dismiss(){
      this.visible = false;
      this.$emit('dismiss');
    }
  },
  beforeUnmount(){ if (this.timer) clearTimeout(this.timer); }
}
</script>

<style scoped>
</style>
